/**
 * ImageOnlyExpandedContent - Image-only product expanded content
 *
 * Renders the expanded row content for image-only products
 * (products that don't need surface textures or 3D models).
 * Simply displays the variant links section.
 */

import React from 'react';
import { VariantLinksSection } from './VariantLinksSection';
import type { ImageOnlyExpandedContentProps } from './types';

export const ImageOnlyExpandedContent: React.FC<ImageOnlyExpandedContentProps> = ({
  variant,
  onVariantLinkChange,
  onVariantAddToCartLinkChange,
}) => {
  return (
    <VariantLinksSection
      variant={variant}
      onVariantLinkChange={onVariantLinkChange}
      onVariantAddToCartLinkChange={onVariantAddToCartLinkChange}
      layout="horizontal"
    />
  );
};

export default ImageOnlyExpandedContent;
